import html2canvas from "html2canvas";
import $ from "jquery";
import { isEmpty, trim } from "lodash";
import _ from "lodash";
import commonStore from "../store/commonStore";
import XRegExp from 'xregexp';

export const captureAndCopyScreenshotWithHtml = async (
  figure: any,
  docLink: string,
  copyURL: string = "",
  shouldCopyShortUrl: boolean = false
) => {
  try {
    const figureNumberLabel = getFigureNumberLabel();
    const selectedFigure = figure?.get(0); // Get the DOM element
    const iframe = figure?.find("iframe");
    const iframeElement = iframe?.[0] as HTMLIFrameElement;
    let dataUrl: any;
    if (isEmpty(iframeElement)) {
      const canvas = await html2canvas(selectedFigure);
      dataUrl = canvas.toDataURL("image/png");
    } else {
      // If there is an iframe, capture its content
      dataUrl = await getCanvasForIframe(iframeElement, selectedFigure);
      if (!dataUrl) {
        console.warn("No data URL generated for the iframe content.");
        return;
      }
    }

    let pubLink = docLink;
    if (!isEmpty(copyURL)) {
      docLink = copyURL;
    }

    const linkText = Base64.decode(
      window.HTML_RENDITION.initialData.doc_headline
    );

    const htmlContent = `
                <div>
                 <a href="${pubLink}">
                    <img src="${dataUrl}" alt="Screenshoted div converted to image" />
                 </a>   
                    <br />
                    <a href="${pubLink}">${linkText}</a>${figureNumberLabel}
                    <br />
                    ${
                      shouldCopyShortUrl
                        ? `<a href="${copyURL}">${copyURL}</a>`
                        : ""
                    }
                </div>
            `;
    const htmlBlob = new Blob([htmlContent], { type: "text/html" });

    const clipboardItem = new ClipboardItem({
      [htmlBlob.type]: htmlBlob,
    });

    try {
      await navigator.clipboard.write([clipboardItem]);
      console.log("Image and HTML content copied to clipboard");
      showTooltip();
    } catch (clipboardError) {
      console.error("Clipboard write failed:", clipboardError);
      fallbackCopy(htmlContent);
    }
  } catch (error) {
    console.error(`Failed to copy figure ${location} to clipboard : `, error);
  }
};

const getFigureNumberLabel = (): string => {
  const figureCaption = $(
    "#right-pane .fg.carousel-item.active .gallary-title .x-rsch-run.CIRCaption "
  );
  const captionText = trim(figureCaption.text());
  const matchNum = captionText?.match(/^(\d+)\./);
  const matchTextFollowedByNum = captionText?.match(XRegExp("^([\\p{L}\\p{M}\\s\\S]+\\s\\d+)\\.", 'u'));
  let figureNumberLabel: string | null = null;
  if (matchNum) {
    const figureNumber = matchNum?.[1];
    figureNumberLabel = ` (Figure ${figureNumber})`;
  }
  else if (matchTextFollowedByNum) {
    const figureNumber = matchTextFollowedByNum?.[1];
    figureNumberLabel = ` (${figureNumber})`;
  }
  else {
    console.log("No figure number found in caption text.");
    figureNumberLabel = "";
  }
  return figureNumberLabel;
};

export const bullbearAnchor = () => {
  const headerClass = $(
    "#left-nav .fg-nav-item.nav_selected .CIRCaptionHeader"
  )?.get(0);
  const headerTitle = headerClass?.innerText;
  const isBullbear = _.includes(headerTitle, "Bull/Bear");
  let anchorName = "";
  if (isBullbear) {
    const docHeaderSectionJson = commonStore.getState().asyncStateReducer
      .docHeaderJsonData;
    const docFileType = window.HTML_RENDITION.initialData?.docFileType;
    let companyCode = '';
    const companiesData = docHeaderSectionJson?.companies?.data;
    _.find(companiesData, (company: any) => {
      let ticker = company?.ticker;
      if (_.includes(headerTitle, ticker)) {
        companyCode = company?.companyCode;
      }
    });

    const bullBearAnchor = companyCode?.replace(".", "_");
    if (_.isEqual("MSWORD", docFileType) && bullBearAnchor) {
      anchorName = "bullBear" + "_" + bullBearAnchor;
    }
    if (_.isEqual("HTML", docFileType)) {
      anchorName = "bodyBullBearPage";
    }
  }
  return anchorName;
};

const getCanvasForIframe = async (
  iframeElement: HTMLIFrameElement,
  selectedFigure: HTMLElement
) => {
  try {
    const iframeDocument =
      iframeElement?.contentDocument || iframeElement?.contentWindow?.document;
    const iframeDocumentBody = iframeDocument?.body;
    let canvasIframe;
    if (iframeDocumentBody) {
      canvasIframe = await html2canvas(iframeDocumentBody);
    } else {
      console.warn("Unable to access iframe content. It may be cross-origin.");
    }

    const clonedFigure = selectedFigure.cloneNode(true) as HTMLElement;
    const clonedIframe = clonedFigure.querySelector("iframe");

    if (canvasIframe && clonedIframe) {
      const canvasDataUrl = canvasIframe.toDataURL("image/png");
      const canvasElement = document.createElement("img");
      canvasElement.src = canvasDataUrl;
      canvasElement.alt = "Screenshoted iframe content";

      // Replace iframe with canvas
      clonedIframe.replaceWith(canvasElement);
    }

    document.body.appendChild(clonedFigure);

    // Capture the cloned element
    const canvas = await html2canvas(clonedFigure);

    // Remove the cloned element from the DOM
    document.body.removeChild(clonedFigure);

    // const canvas = await html2canvas(selectedFigure);
    const dataUrl = canvas?.toDataURL("image/png");
    return dataUrl;
  } catch (error) {
    console.error("Failed to capture iframe content:", error);
    return null;
  }
};

function fallbackCopy(content: string) {
  // Create a temporary div element to hold the HTML content
  const fallbackDiv = document.createElement("div");
  fallbackDiv.innerHTML = content; // Set the HTML content
  fallbackDiv.style.position = "absolute";
  fallbackDiv.style.left = "-9999px"; // Move it off-screen
  document.body.appendChild(fallbackDiv);

  // Select the content of the div
  const range = document.createRange();
  range.selectNodeContents(fallbackDiv);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);

  // Execute the copy command
  document.execCommand("copy");
  document.body.removeChild(fallbackDiv); // Clean up the temporary div
  console.log("Fallback: HTML content copied to clipboard");
  showTooltip();
}

function showTooltip() {
  $(".copy-figure-tooltip").addClass("show");
  setTimeout(hideTooltip, 1000);
}

// Function to hide the tooltip
function hideTooltip() {
  $(".copy-figure-tooltip").removeClass("show");
}
